/**
 * @flow
 * @relayHash 9fe83a4e7857c8c19f5ae5d6166b8e76
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateOrderYieldInput = {|
  id: string,
  itemId?: ?string,
  orderedQuantity?: ?number,
  unitPrice?: ?number,
  discountPercent?: ?number,
|};
export type UpdateOrderYieldMutationVariables = {|
  input: UpdateOrderYieldInput
|};
export type UpdateOrderYieldMutationResponse = {|
  +updateOrderYield: {|
    +orderYieldEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +orderedQuantity: number,
        +unitPrice: ?number,
        +discountPercent: ?number,
        +lineTotal: ?number,
        +order: {|
          +id: string,
          +subtotal: ?number,
          +discountAmount: ?number,
          +taxAmount: ?number,
          +totalAmount: ?number,
        |},
        +item: {|
          +id: string,
          +itemNumber: string,
          +name: string,
          +partNumber: ?string,
          +description: ?string,
        |},
      |},
    |}
  |}
|};
export type UpdateOrderYieldMutation = {|
  variables: UpdateOrderYieldMutationVariables,
  response: UpdateOrderYieldMutationResponse,
|};
*/


/*
mutation UpdateOrderYieldMutation(
  $input: UpdateOrderYieldInput!
) {
  updateOrderYield(input: $input) {
    orderYieldEdge {
      cursor
      node {
        id
        orderedQuantity
        unitPrice
        discountPercent
        lineTotal
        order {
          id
          subtotal
          discountAmount
          taxAmount
          totalAmount
        }
        item {
          id
          itemNumber
          name
          partNumber
          description
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateOrderYieldInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateOrderYield",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOrderYieldPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "orderYieldEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderYieldEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "OrderYield",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "orderedQuantity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "unitPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountPercent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lineTotal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "subtotal",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "discountAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "taxAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalAmount",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "partNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateOrderYieldMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateOrderYieldMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateOrderYieldMutation",
    "id": null,
    "text": "mutation UpdateOrderYieldMutation(\n  $input: UpdateOrderYieldInput!\n) {\n  updateOrderYield(input: $input) {\n    orderYieldEdge {\n      cursor\n      node {\n        id\n        orderedQuantity\n        unitPrice\n        discountPercent\n        lineTotal\n        order {\n          id\n          subtotal\n          discountAmount\n          taxAmount\n          totalAmount\n        }\n        item {\n          id\n          itemNumber\n          name\n          partNumber\n          description\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '57e2fce9030ca30f64a0a6bf26949c20';
module.exports = node;
